// Central asset + content config for GAIA SPACE
export const IMAGES = {
  hero: "/hero-tree.jpg",
  comingSoonTexture: "https://images.pexels.com/photos/13620627/pexels-photo-13620627.jpeg?auto=compress&cs=tinysrgb&w=1600",
  newsletterBg: "https://images.pexels.com/photos/7023474/pexels-photo-7023474.jpeg?auto=compress&cs=tinysrgb&w=1600",
  founder: "https://images.pexels.com/photos/14776509/pexels-photo-14776509.jpeg",
  founderDetail: "https://images.pexels.com/photos/7578230/pexels-photo-7578230.jpeg",
  offerMovement: "https://images.pexels.com/photos/10176085/pexels-photo-10176085.jpeg",
  offerBreath: "https://images.unsplash.com/photo-1570276095143-a627b6514b1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  offerGatherings: "https://images.unsplash.com/photo-1665607438186-7755c7f4dd30?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  stone: "https://images.pexels.com/photos/19836383/pexels-photo-19836383.jpeg",
};

// Coming Soon left-column carousel (user-provided, duotone-graded via CSS)
export const COMING_SOON_CAROUSEL = [
  "/carousel/cs1.webp",
  "/carousel/cs2.webp",
  "/carousel/cs3.webp",
  "/carousel/cs4.webp",
];

export const OFFERINGS = [
  {
    id: "movement",
    index: "01",
    title: "Movement",
    copy: "Move with awareness. Rediscover the intelligence of your body.",
    image: IMAGES.offerMovement,
  },
  {
    id: "breath",
    index: "02",
    title: "Breath",
    copy: "A return to stillness through conscious breathing.",
    image: IMAGES.offerBreath,
  },
  {
    id: "gatherings",
    index: "03",
    title: "Gatherings",
    copy: "Intimate experiences designed to reconnect you with yourself, nature and others.",
    image: IMAGES.offerGatherings,
  },
];

export const PILLARS = ["Nature", "Presence", "Movement", "Breath", "Connection"];
